export const CUT_MUSIC_EXAMPLE_IMAGES = {
  SHIFT: '/assets/img/cut_music_examples/shift-illustration.png',
  DROP: '/assets/img/cut_music_examples/drop-illustration.png',
  EXAMPLE_0SEC: '/assets/img/cut_music_examples/example-0sec.png',
  EXAMPLE_30SEC: '/assets/img/cut_music_examples/example-30sec.png',
  EXAMPLE_60SEC: '/assets/img/cut_music_examples/example-60sec.png',
};
